import React from 'react';

import { IconButton, LinkIconButton } from '@atlaskit/button/new';

import type { PreviewPanelActionProps } from './types';

export const PreviewPanelAction = React.forwardRef(function PreviewPanelAction(
	{ icon, label, onClick, href, testId, analyticsContext }: PreviewPanelActionProps,
	ref: React.Ref<any>,
) {
	return href ? (
		<LinkIconButton
			icon={icon}
			label={label}
			onClick={onClick}
			href={href}
			testId={testId}
			analyticsContext={analyticsContext}
			appearance="subtle"
			target="_blank"
			ref={ref}
			role="button"
		/>
	) : (
		<IconButton
			icon={icon}
			label={label}
			onClick={onClick}
			testId={testId}
			analyticsContext={analyticsContext}
			appearance="subtle"
			ref={ref}
			role="button"
		/>
	);
});
